import { React, useState, Box, Divider, IconButton, ArrowBackIosIcon, Grid2, SelectChangeEvent, Typography, useEffect, Dayjs } from '../../utils/globalImports';
import { CustomDropdown, CustomButton, SearchBar, useApi, ContactType, ContactTypeId, ProposalType, CustomDatePicker, Paper } from '../../utils/globalImports';
import { FilterListOutlined } from "@mui/icons-material";
interface Option {
    value: string | number;
    text: string;
}

interface FilterCardProps {
    [key: string]: any;

    handleArrowBackNavigation?: () => void;
    handleModalOrNavigate?: () => void; // to open the modal from FilterCard
    handleSearch: (query: string, status: number, category?: number, region?: number, contactType?: number, date?: string, proposalType?: number, startDate?: string,
        endDate?: string) => void;
    dateLabel?: string;
    showDateRange?: boolean;
    showDateFilter?: boolean;
    ignoreAttachmentDate?: boolean;
}

const FilterCard: React.FC<FilterCardProps> = ({ handleArrowBackNavigation, handleModalOrNavigate, handleSearch, ...props }) => {
    const { clientId = 0, frameworkId = 0, projectId = 0, showProposalTypeDropdown = false, showUserTypeDropdown = false, showNotesComments = false, showClientDropdown = false, showframeworkField = false, showContactTypeDropdown = false, title = '', actionText = '', searchbarText = '', showActiveFilter = true, showDateFilter = true, ignoreAttachmentDate = false } = props;
    const [query, setQuery] = useState("");
    const [status, setStatus] = useState<number>(1);
    const [date, setDate] = useState<Dayjs | null>(null);
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [endDate, setEndDate] = useState<Dayjs | null>(null);
    const [category, setCategory] = useState<number>(-1);
    const [region, setRegion] = useState<number>(-1);
    const [contactType, setContactType] = useState<number>(-1);
    const [categoryOption, setCategoryOption] = useState<Option[]>([]);
    const [regionOption, setRegionOption] = useState<Option[]>([]);
    const [contactTypeOption, setContactTypeOption] = useState<Option[]>([]);
    const [userType, setUserType] = useState<number>(-1);
    const [proposalType, setProposalType] = useState<number>(-1);
    const [proposalTypeOption, setProposalTypeOption] = useState<Option[]>([]);

    const { execute } = useApi();

    useEffect(() => {

        if (title === 'Clients') {
            fetchCategory();
            fetchRegion();
        }
        else if (title === 'Client Contact') {
            // fetchContactType()
        }
        else if (showProposalTypeDropdown) fetchProposalType()

    }, [])

    const handleStartDateChange = (value: Dayjs | null) => {
        setStartDate(value);

        if (value) {
            const lastDay = value.endOf("month"); // auto calculate last day of month
            setEndDate(lastDay);
        } else {
            setEndDate(null);
        }
    };

    // fetch ClientCategory
    const fetchCategory = async () => {
        const { data } = await execute('get', '/LookUp/GetCategories');
        if (data && Array.isArray(data)) {
            const categoryOptions = data
                .filter((category: any) => category.status === true) // Filter active category
                .map((category: any) => ({
                    value: category.categoryId,  // Ensure `id` exists in the response
                    text: category.categoryName, // Ensure `name` exists in the response
                }))
                .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting
            setCategoryOption(categoryOptions);
        }
    }



    // fetch ClientRegion
    const fetchRegion = async () => {
        const { data } = await execute('get', '/LookUp/GetRegions');
        if (data && Array.isArray(data)) {
            const regionOptions = data
                .filter((region: any) => region.status === true) // Filter active region
                .map((region: any) => ({
                    value: region.regionId,  // Ensure `id` exists in the response
                    text: region.regionName, // Ensure `name` exists in the response
                }))
                .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' })); // Case-insensitive sorting
            setRegionOption(regionOptions);
        }
    }

    // fetch ContactType
    const fetchContactType = async () => {
        const categoryOptions = Object.entries(ContactType).map(([id, description]) => ({
            value: id,  // Ensure `id` exists in the response
            text: description, // Ensure `name` exists in the response
        }))
            .sort((a, b) => a.text.localeCompare(b.text));
        setContactTypeOption(categoryOptions);
    }

    const userTypeOptions = [
        { value: 1, text: "Technical Project Lead" },
        { value: 2, text: "Assistant Technical Project Lead" }
    ];

    // fetch ProposalType
    const fetchProposalType = async () => {
        const proposalTypeOptions = Object.entries(ProposalType).map(([id, description]) => ({
            value: id,  // Ensure `id` exists in the response
            text: description, // Ensure `name` exists in the response
        }))
            .sort((a, b) => a.text.localeCompare(b.text));
        setProposalTypeOption(proposalTypeOptions);
    }


    const handleQueryChange = (updatedQuery: string) => {
        setQuery(updatedQuery); // Update the query in FilterCard
    };

    const handleSearchClick = () => {
        const formattedDate = date?.format("YYYY-MM-DD");
        const formattedStart = startDate?.format("YYYY-MM-DD");
        const formattedEnd = endDate?.format("YYYY-MM-DD");
        //const formattedStatus=status?.

        if (props.showDateRange) {
            handleSearch(
                query,
                status,
                category,
                region,
                contactType,
                formattedDate,
                proposalType,
                formattedStart,
                formattedEnd
            );
            return;
        }
        if (title === 'Clients') {
            handleSearch(query, status, category, region)
        }
        else if (title === 'Client Contact') {
            handleSearch(query, status)
        }
        else if (title === 'Frameworks') {
            handleSearch(query, status, 0, 0, 0, date?.format("YYYY-MM-DD"))
        }
        else if (title === 'Client Notes') {
            handleSearch(query, status, 0, 0, 0, date?.format("YYYY-MM-DD"));
        }
        else if (title === 'Project Notes') {
            handleSearch(query, status, 0, 0, 0, date?.format("YYYY-MM-DD"));
        }
        else if (title === ' ') {
            handleSearch(query, status, userType)
        }
        else if (title === 'Projects') {
            handleSearch(query, status, 0, 0, 0, date?.format("YYYY-MM-DD"))
        }
        else if (actionText === 'Add Proposal') {
            handleSearch(query, status, 0, 0, 0, '', proposalType)
        }
        else if (title === 'Proposal Notes') {
            handleSearch(query, status, 0, 0, 0, date?.format("YYYY-MM-DD"))
        }
        else if (title === 'Proposal Attachments') {
            handleSearch(query, status, 0, 0, 0, date?.format("YYYY-MM-DD"));
        }
        else {
            handleSearch(query, status);
        }
    };

    return (
        <Box>

            {!showNotesComments && (
                <Grid2 container spacing={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 6 }}>
                    <Grid2 sx={{ display: 'flex', alignItems: 'center' }}>
                        {showProposalTypeDropdown && (
                            <IconButton sx={{ width: '40px', height: '40px', backgroundColor: 'transparent' }} onClick={handleArrowBackNavigation} >
                                <ArrowBackIosIcon sx={{ color: '#1e66ab', fontSize: '15px' }} />
                            </IconButton>
                        )}

                        <Typography
                            noWrap
                            sx={{
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                lineHeight: "60px",
                                color: "rgb(30, 102, 171)",
                                mb: 1,

                                ...(title === 'Add Proposal' ? { mb: 0 } : {}),
                                fontSize:
                                    title === 'Client Contact' ||
                                        title === 'Fee Stage' ||
                                        title === 'Fee stage Sub Category'
                                        ? '24px'
                                        : '40px',
                            }}
                        >
                            {title}
                        </Typography>
                    </Grid2>

                    {/* Add Button */}
                    <Grid2
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 2,
                        }}
                        sx={{
                            mt: 0,
                            ...(['Add Client Category', 'Add Client Region', 'Add Fee Stage Area', 'Add Tag', 'Add Personnel'].includes(actionText) && {
                                '@media screen and (min-width: 1024px) and (max-width: 1100px)': {
                                    flexBasis: '18%',
                                    maxWidth: '18%',
                                },
                                '@media screen and (min-width: 1101px) and (max-width: 1280px)': {
                                    flexBasis: '15%',
                                    maxWidth: '15%',
                                },
                            }),
                        }}
                    >

                        <CustomButton
                            capsule
                            sx={{
                                mt: -1,
                                mb: 2,
                                textTransform: 'none',
                                whiteSpace: 'nowrap',
                                ...(['Add Client Category', 'Add Client Region', 'Add Fee Stage Area', 'Add Tag', 'Add Personnel'].includes(actionText) && {
                                    '@media screen and (min-width: 1024px) and (max-width: 1100px)': {
                                        minWidth: '115px',
                                        fontSize: '0.7rem',
                                        padding: '5px 8px',
                                    },
                                    '@media screen and (min-width: 1101px) and (max-width: 1280px)': {
                                        minWidth: '130px',
                                        fontSize: '0.75rem',
                                        padding: '6px 10px',
                                    },
                                }),
                            }}
                            disabled={((title === 'Fee Stage' && frameworkId === 0) ? true : false) ||
                                ((actionText === 'Add Party' && projectId === 0) ? true : false) ||
                                (title === 'Client Contact' && clientId === 0) ? true : false
                            }
                            onClick={handleModalOrNavigate}
                        >
                            {actionText}
                        </CustomButton>
                    </Grid2>
                </Grid2>
            )}

            <Paper elevation={0} sx={{ border: '1px solid #e0eaf6', borderRadius: '14px', overflow: 'hidden' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 1.5, backgroundColor: '#f0f6ff', borderBottom: '1px solid #e0eaf6' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FilterListOutlined sx={{ fontSize: 18, color: '#1e66ab' }} />
                        <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1e66ab', fontFamily: 'Poppins' }}>
                            Filters
                        </Typography>
                    </Box>
                </Box>
                <Grid2 container spacing={2}
                    sx={{
                        flexWrap: "wrap",
                        gap: 1,
                        display: "flex",
                        flexDirection: "row",
                        padding: '12px 20px 12px 20px',
                        backgroundColor: '#f7faff'
                    }} >
                    {/* Search Bar */}
                    <Grid2 size={{ xs: 12 }}>
                        <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#888', textTransform: 'uppercase', letterSpacing: '0.8px', fontFamily: 'Poppins', }}>
                            Search & Filter
                        </Typography>
                    </Grid2>
                    <Grid2
                        size={{
                            xs: 12,
                            md: 6,
                            lg: (props.showDateRange) ? 4 :
                                (!showActiveFilter)
                                    ? 8
                                    : (showClientDropdown)
                                        ? 4
                                        : (
                                            showframeworkField ||
                                            // showContactTypeDropdown ||
                                            showNotesComments ||
                                            showUserTypeDropdown ||
                                            showProposalTypeDropdown
                                        )
                                            ? 6
                                            : 8
                        }}
                    >
                        <SearchBar
                            placeholder={searchbarText}
                            onQueryChange={handleQueryChange}
                            sx={{
                                // fontSize: '14px'

                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearchClick();
                                }
                            }} />
                    </Grid2>

                    {showClientDropdown && (
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomDropdown
                                value={category}
                                onChange={(event: SelectChangeEvent<string | number>) => setCategory(Number(event.target.value))}
                                label="Select Category"
                                options={categoryOption}
                                sx={{
                                    backgroundColor: '#fff'
                                }}
                            />
                        </Grid2>
                    )}

                    {showClientDropdown && (
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomDropdown
                                value={region}
                                onChange={(event: SelectChangeEvent<string | number>) => setRegion(Number(event.target.value))}
                                label="Select Region"
                                options={regionOption}
                                sx={{
                                    backgroundColor: '#fff'
                                }}
                            />
                        </Grid2>
                    )}

                    {/* {showContactTypeDropdown && (
                    <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                        <CustomDropdown
                            value={contactType}
                            onChange={(event: SelectChangeEvent<string | number>) => setContactType(Number(event.target.value))}
                            label="Contact Type"
                            options={contactTypeOption}
                            sx={{ boxShadow: "0px 4px 12px 4px #d7d7d7" }}
                        />
                    </Grid2>
                )} */}
                    {showUserTypeDropdown && (
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomDropdown
                                value={userType}
                                onChange={(event: SelectChangeEvent<string | number>) => setUserType(Number(event.target.value))}
                                label="User Type"
                                options={userTypeOptions}
                                sx={{
                                    backgroundColor: '#fff'
                                }}
                            />
                        </Grid2>
                    )}

                    {showProposalTypeDropdown && (
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            <CustomDropdown
                                value={proposalType}
                                onChange={(event: SelectChangeEvent<string | number>) => setProposalType(Number(event.target.value))}
                                label="Proposal Type"
                                options={proposalTypeOption}
                                sx={{
                                    backgroundColor: '#fff'
                                }}
                            />
                        </Grid2>
                    )}



                    {/* status Dropdown */}
                    {showActiveFilter && (<Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                        <CustomDropdown
                            value={status}
                            onChange={(event: SelectChangeEvent<string | number>) => setStatus(Number(event.target.value))}
                            label="Select Status"
                            sx={{
                                backgroundColor: '#fff'
                            }}
                        />
                    </Grid2>)}

                    {(!ignoreAttachmentDate && (showframeworkField || showNotesComments) && !props.showDateRange) && (
                        <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                            {showDateFilter && (
                                <CustomDatePicker
                                    //label="Date"
                                    label={props.dateLabel || "Date"}
                                    value={date}
                                    onChange={setDate}
                                    height={43}
                                    sx={{
                                        borderRadius: "50px",
                                        backgroundColor: '#fff'
                                    }}
                                />
                            )}
                        </Grid2>
                    )}

                    {/* Date Filters */}

                    <>

                        {/* NEW Start Date Filter */}
                        {props.showDateRange && (
                            <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                                <CustomDatePicker
                                    label="Start Date"
                                    value={startDate}
                                    //onChange={setStartDate}
                                    onChange={handleStartDateChange}
                                    height={43}
                                    sx={{
                                        borderRadius: "50px",
                                        backgroundColor: '#fff'
                                    }}
                                />
                            </Grid2>
                        )}

                        {/* NEW End Date Filter */}
                        {props.showDateRange && (
                            <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                                <CustomDatePicker
                                    label="End Date"
                                    value={endDate}
                                    onChange={setEndDate}
                                    //onChange={() => { }}
                                    //disabled={true}
                                    height={43}
                                    sx={{
                                        borderRadius: "50px",
                                        backgroundColor: '#fff'
                                    }}
                                />
                            </Grid2>
                        )}
                    </>


                    {/* Search Button */}
                    <Grid2 size={{ xs: 12, md: 6, lg: 2 }}>
                        <CustomButton
                            capsule
                            sx={{
                                mt: 0,
                                mb: 2,
                                textTransform: 'none'
                            }}
                            backgroundColor="#1e66ab"
                            hoverColor="rgba(150, 193, 33, 0.75)"
                            onClick={handleSearchClick} // Trigger search when clicked
                        >
                            Search
                        </CustomButton>
                    </Grid2>
                </Grid2>
            </Paper>
        </Box>
    );
}

export default FilterCard;